import { skipToken, useQuery } from '@tanstack/react-query';

import { getInvestmentComplianceLimitOptions } from '../../api/portalGateway/getInvestmentComplianceLimitOptions';

const OPTIONS_STALE_TIME = 5 * 60 * 1000;

export function useInvestmentComplianceLimitOptions(
  contentId: string,
  dataLevelIndex: number | null
) {
  return useQuery({
    queryKey: [
      'investment-compliance-limit-options',
      contentId,
      dataLevelIndex,
    ],
    queryFn:
      dataLevelIndex == null
        ? skipToken
        : () => getInvestmentComplianceLimitOptions(contentId, dataLevelIndex),
    enabled: dataLevelIndex != null,
    staleTime: OPTIONS_STALE_TIME,
  });
}
